import React from 'react';
import { ShieldCheck, X } from 'lucide-react';

const AgeGate = ({ onAccept }) => {
  return (
    <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md flex items-center justify-center p-4">
      <div className="max-w-lg w-full bg-[#1a1417] border border-[#3a2530] rounded-2xl p-8 shadow-2xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#a83a5b] to-[#7a1f3d] flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-white" strokeWidth={2} />
          </div>
          <span className="text-xs tracking-[0.2em] uppercase text-[#c19a8a] font-medium">18+</span>
        </div>
        <h2 className="text-2xl font-serif text-white mb-3">Willkommen auf matchdate.ch</h2>
        <p className="text-[#b8a9a3] leading-relaxed mb-2">
          Diese Plattform ist ausschliesslich für volljährige Personen. Sie enthält Inhalte und Inserate, die für Minderjährige ungeeignet sind.
        </p>
        <p className="text-[#b8a9a3] leading-relaxed mb-6">
          Mit dem Eintreten bestätigst du, dass du mindestens 18 Jahre alt bist und mit der Anzeige adult-orientierter Inhalte einverstanden bist.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={onAccept}
            className="flex-1 px-5 py-3 rounded-md bg-[#a83a5b] hover:bg-[#bf456b] text-white font-medium transition-colors duration-200"
          >
            Ja, ich bin 18+ – Eintreten
          </button>
          <a
            href="https://www.google.ch"
            className="flex-1 px-5 py-3 rounded-md border border-[#3a2530] hover:bg-[#241a1f] text-[#b8a9a3] font-medium transition-colors duration-200 text-center inline-flex items-center justify-center gap-2"
          >
            <X className="w-4 h-4" /> Nein, verlassen
          </a>
        </div>
        <p className="text-xs text-[#7a6b65] mt-5 leading-relaxed">
          Mit dem Eintreten akzeptierst du unsere AGB & Datenschutzerklärung. matchdate.ch verwendet keine Tracking-Cookies.
        </p>
      </div>
    </div>
  );
};

export default AgeGate;
